import React from "react";

export default function MediaListNav({ title = "", actions }) {
  return (
    <div>
      <header className="flex flex-row items-center justify-between border-b border-[#0075FF1A] px-[30px] py-[20px]">
        <h2 className="text-left font-outfit text-[20px] font-medium leading-[25.2px] text-[#222222]">
          {title}
        </h2>
        <div className="relative">
          {/* <Searchbar placeholder="Search Videos" /> */}
        </div>

        <div className="flex flex-row items-center gap-4">
          {actions.map((item, index) => (
            <div key={index}>{item.component}</div>
          ))}
        </div>
      </header>
    </div>
  );
}
